import { Row } from 'react-bootstrap';
import React from 'react';
import '../styles/ProductAddToCartForm.css';

/**
 * Component for showing the "add to cart" form with or without options.
 * SKELETON MODE
 * @component
 */
const ProductAddToCartFormSkeleton = ({

}) => {
    return <div
        className={'addtocart--form loading'}
        style={{
            height: '173.2px',
        }}>
        <div
            className={'addtocart--option'}>
            <label>Quantity</label>
        </div>
        <div
            className={'addtocart--submit-section'}>
            <div
                className={'input-quantity--container'}
                style={{
                    height: '46px',
                }}>
            </div>
            <Row
                className={'addtocart--row'}>
                <div
                    className={'addtocart--submit-button'}
                    style={{
                        height: '51.6px',
                    }}>
                </div>
                <div
                    className={'addtocart--submit-button'}
                    style={{
                        height: '51.6px',
                    }}>
                </div>
            </Row>
        </div>
    </div>;
};
export default ProductAddToCartFormSkeleton;
